/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

// import Types from '../../../common/modules/types';

const isNotBlendMode = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'BLEND_MODE',
]);

export default [
  ...[
    getFilterWithCol(['FieldRadio', {
      label: null,
      name: 'blend_mode_type',
      initialValue: 'NORMAL',
      block: true,
      choices: ['Normal', 'Overlay', 'Multiply', 'Screen'].map(label => ({
        value: label.toUpperCase(),
        label,
      })),
    }, 24]),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotBlendMode, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
